__turbopack_context__.v({
  "navBar": "SimpleHeaderMobile-module-scss-module__45dZgq__navBar",
  "navWrapper": "SimpleHeaderMobile-module-scss-module__45dZgq__navWrapper",
});
